<!--
  Acomodo segun el ancho del componente padre (app-config-sensors-device):
  con espacio, cada sensor es una fila "etiqueta | slider | acciones";
  en contenedores angostos (.cfg-narrow) la etiqueta y las acciones van arriba
  y el slider ocupa todo el ancho debajo. Estilos en config.scss.
-->
<div class="min-max-header">
  <h3 class="m-0">{{ "min-max-config.title" | translate }}</h3>
  <div class="min-max-header__actions" *ngIf="permissions.change_parametricpreference">
    <button class="btn btn-danger" (click)="removeConfiguration()" *ngIf="type !== 'farm'">
      {{ "min-max-config.remove-config" | translate }}
    </button>
    <button class="btn btn-success" (click)="submitAutomaticRequest()">
      {{ "fuzzy-logic-config.save-changes" | translate }}
    </button>
  </div>
</div>
<p class="min-max-description">{{ "min-max-config.description" | translate }}</p>

<div class="config-devices">
  <div
    class="sensor-row"
    *ngFor="let item of resourses_data; let i = index"
    [ngClass]="{ 'd-none': type !== 'farm' && !checks_parametry_preference[item.preference] }"
  >
    <span class="sensor-row__label">{{ item.label | translate }}</span>

    <div class="sensor-row__slider custom-slider">
      <ngx-slider
        [(value)]="item.min_value"
        [(highValue)]="item.max_value"
        [options]="validateOptions(item)"
      ></ngx-slider>
    </div>

    <div
      class="sensor-row__actions"
      *ngIf="type !== 'feeder' && permissions.change_parametricpreference"
    >
      <label class="switch m-0">
        <input type="checkbox" [(ngModel)]="item.check" (change)="changeCheck(item)" />
        <span class="slider round"></span>
      </label>

      <em
        *ngIf="viewNotifications"
        class="fa c-pointer sensor-row__bell"
        role="button"
        tabindex="0"
        [ngClass]="sendNotification(item.preference) ? 'fa-bell text-primary' : 'fa-bell-slash'"
        (click)="changePreferenceNotification(item)"
        (keydown.enter)="changePreferenceNotification(item)"
      ></em>
    </div>
  </div>
</div>
